export enum PaymentSource {
  Revolut = 0,
  Trustpay = 1,
  Qonto = 2,
  Commerzbank = 3,
  MicroPayment = 4,
  Moorwand = 5,
}

export enum TrustpayTransactionStatus {
  Unknown = 0,
  NeedsUserCheck = 1,
  UserChecked = 2,
  AutoCommitted = 3,
}
